
import React from 'react';
import { CheckCircle, AlertCircle, RotateCcw, X } from 'lucide-react';

export interface ToastMessage {
  id: string;
  type: 'success' | 'error' | 'info';
  text: string;
  onUndo?: () => void;
}

interface ToastProps {
  toast: ToastMessage | null;
  onClose: () => void;
}

export const Toast: React.FC<ToastProps> = ({ toast, onClose }) => {
  if (!toast) return null;

  const typeStyles = {
    success: 'bg-white dark:bg-slate-800 text-slate-900 dark:text-white',
    error: 'bg-red-50 dark:bg-red-900/20 text-red-800 dark:text-red-200',
    info: 'bg-blue-50 dark:bg-blue-900/20 text-blue-800 dark:text-blue-200',
  };

  const iconColors = {
    success: 'text-green-500',
    error: 'text-red-500',
    info: 'text-blue-500',
  };

  return (
    <div className="fixed top-6 right-6 z-[1200] animate-fade-in max-w-sm w-full">
      <div className={`p-4 rounded-ds-card shadow-ds-card flex items-center gap-3 ${typeStyles[toast.type]}`}>
        {toast.type === 'success' ? (
          <CheckCircle size={20} className={iconColors.success} />
        ) : (
          <AlertCircle size={20} className={iconColors[toast.type]} />
        )}
        
        <p className="flex-1 text-ds-body font-medium">{toast.text}</p>
        
        {toast.onUndo && (
          <button 
            onClick={toast.onUndo}
            className="text-ds-meta font-medium bg-slate-100 dark:bg-slate-700 px-3 py-1.5 rounded-ds-button hover:bg-slate-200 dark:hover:bg-slate-600 transition-colors flex items-center gap-1"
          >
            <RotateCcw size={12} /> Zpet
          </button>
        )}

        <button onClick={onClose} className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 p-1 transition-colors">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};
